import { BASE_URL, getAuthBearerHeaders } from "../shared";

export interface ModelInfo {
  artistname: string;
  urlParam: string;
  image: { url: string; blurhash: string };
  _id: string;
  likes: number;
  uses: number;
  private: boolean;
  trending: {
    isTrending: boolean;
    position: number;
  };
  user: {
    username: string;
  };
  info: {
    uploadedBy: string;
  };
  pitchScaling?: number;
}

export interface Conversion {
  _id: string;
  conversionStatus: string;
  isFree: boolean;
  shortid: string;
  name?: string;
  downloads: number;
  status:
    | "waiting"
    | "pending"
    | "success"
    | "failed"
    | "pending_source"
    | "advancing"
    // A free user's saved Create (never run) and its unlock states; see
    // apps/web/pages/api/v2/conversion/unlock.
    | "locked"
    | "unlocking"
    | "unlocked";
  progress?: number;
  /** How far the jammer has got, 1-4 (separating, setting up, singing, final touches). */
  stage?: number;
  info: {
    acapella: "extracting" | "extracted";
    model: "waiting" | "applying" | "applied";
  };
  instrumentalUrl?: string;
  convertedUrl?: string;
  model: {
    artistname: string;
    urlParam: string;
    image: { url: string };
  };
  outputUrls?: {
    audio: string;
    video?: string;
    transcription?: string;
  };
  // The owner's public profile only: getConversion no longer returns their
  // firebaseUid, credits or subscriptions.
  user: {
    _id: string;
    username: string;
    avatar: string;
    verifiedAccount?: boolean;
  };
  models?: ModelInfo[];
  duration?: number;
  clip?: {
    inTime?: number;
    outTime?: number;
    duration?: number;
  };
  videoSettings?: {
    progress?: number;
    template?: any;
    externalTemplate?: {
      composition?: string;
      templateId?: string;
      name?: string;
      background?: any;
    };
    externalVideoId?: string;
  };
  inputFiles?: any[];
}

export async function fetchConversion(id: string): Promise<Conversion> {
  console.log(BASE_URL);
  const response = await fetch(
    `${BASE_URL}/api/model/getConversion?conversionId=${id}`,
    {
      headers: {
        ...(await getAuthBearerHeaders()),
      },
    },
  );
  const data = await response.json();
  return data.conversion;
}
